export enum EditorHTMLMode {
  NORMAL = 0,
  PREVIEW = 1,
}
